<div class="container-fluid container-lg g-lg-0" *ngIf="regionState$ | async as state">
  <div class="row">
    <div class="col-lg map-column" [class.mobile-active]="regionService.showMap$ | async">
      <x-address-map
        mapHeight="100%"
        [showCoordinates]="false"
        [polygons]="state.deliveryPolygons"
        [markers]="state.deliveryMarkers"
        [addressMarker]="state.addressInput?.coordinates"
        [defaultCoordinates]="state.defaultCoordinates"
        (coordinatesUpdate)="regionService.updateCoordinates($event)"
        [showBounds]="true"
      >
        <x-loader xLoader></x-loader>
      </x-address-map>
      <x-region-overlay-footer></x-region-overlay-footer>
    </div>
    <div class="col-lg region-details">
      <x-region-normal-flow *ngIf="state.mode === 'normal'"></x-region-normal-flow>
      <x-region-add-to-cart-flow *ngIf="state.mode === 'add-to-cart'"></x-region-add-to-cart-flow>
      <x-region-overlay-footer></x-region-overlay-footer>
    </div>
  </div>
</div>

<!--loader-->
<ng-container *ngIf="regionService.operationQState$ | async as operation">
  <x-loader *ngIf="operation.status === 'loading'"></x-loader>
</ng-container>
